import { isPreviewThumbLoadingEnabled } from '../consts';
import { useStationThumbnailBrand } from '../hooks/useStationThumbnailBrand';
import { useThumbnailForTs, UseThumbnailOptions } from '../hooks/useThumbnailForTs';
import { generateFallbackThumbnailDisplayInfo } from '../utils';
import { LoadingThumbnail } from './LoadingThumbnail';
import { MissingThumbnail } from './MissingThumbnail';
import { PreloadedThumbnail } from './PreloadedThumbnail';

interface Props {
  stationId: string;
  ts: number;
  animated?: boolean;
  useThumbnailOptions?: UseThumbnailOptions;
  targetHeight?: number;
}

export function TsThumbnail({ stationId, ts, animated, useThumbnailOptions, targetHeight }: Props) {
  const thumb = useThumbnailForTs(stationId, ts, useThumbnailOptions);
  const { logoUrl, stationName } = useStationThumbnailBrand(stationId);

  if (isPreviewThumbLoadingEnabled() || thumb.isLoading) {
    return (
      <LoadingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        targetHeight={targetHeight}
        logoUrl={logoUrl}
        stationName={stationName}
      />
    );
  }

  if (!thumb.info) {
    return (
      <MissingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        targetHeight={targetHeight}
      />
    );
  }

  return (
    <PreloadedThumbnail
      {...thumb.info}
      animated={animated}
      targetHeight={targetHeight}
      logoUrl={logoUrl}
      stationName={stationName}
    />
  );
}
